import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const PasswordShowSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0015 5.60504C9.06685 5.60504 6.54541 6.81563 4.75899 8.21215C3.86561 8.91054 3.15384 9.65711 2.66448 10.3255C2.41983 10.6597 2.22972 10.9758 2.10039 11.2578C1.97183 11.5382 1.89999 11.7922 1.89999 12C1.89999 12.207 1.9716 12.4603 2.09977 12.7402C2.22872 13.0218 2.4183 13.3376 2.66237 13.6716C3.15058 14.3397 3.86097 15.0865 4.75345 15.7853C6.53809 17.1827 9.05955 18.3949 12.0015 18.3949C14.9743 18.3949 17.4951 17.1828 19.2715 15.7852C20.1598 15.0863 20.864 14.3394 21.3471 13.6712C21.5886 13.3371 21.7759 13.0213 21.9031 12.7397C22.0296 12.4598 22.1 12.2067 22.1 12C22.1 11.7925 22.0294 11.5387 21.9025 11.2583C21.7749 10.9763 21.5871 10.6602 21.345 10.326C20.8608 9.65744 20.1552 8.91078 19.2659 8.21229C17.4878 6.81551 14.967 5.60504 12.0015 5.60504ZM3.2511 12C3.2511 11.9114 3.3006 11.7616 3.4158 11.5567C3.52855 11.3562 3.69668 11.116 3.91586 10.8509C4.35403 10.3212 4.99107 9.69854 5.78258 9.10392C7.36659 7.91393 9.55851 6.84399 12.0015 6.84399C14.4397 6.84399 16.6292 7.9139 18.2121 9.1039C19.0031 9.69852 19.6398 10.3212 20.0779 10.8509C20.297 11.1159 20.4651 11.3562 20.5778 11.5567C20.693 11.7616 20.7425 11.9114 20.7425 12C20.7425 12.1072 20.6913 12.2708 20.577 12.4829C20.4643 12.6919 20.2964 12.9373 20.0775 13.2049C19.6399 13.7399 19.0035 14.3573 18.2127 14.9428C16.6304 16.1144 14.4406 17.1501 12.0015 17.1501C9.55762 17.1501 7.36545 16.1143 5.78199 14.9428C4.99067 14.3573 4.35399 13.7398 3.91619 13.2049C3.69721 12.9373 3.5293 12.6919 3.41666 12.4829C3.30232 12.2708 3.2511 12.1072 3.2511 12ZM12.0015 7.76849C9.63758 7.76849 7.74148 9.63423 7.75113 12.0004C7.76378 14.3038 9.63576 16.2315 12.0015 16.2315C14.3454 16.2315 16.2453 14.3045 16.2453 12C16.2453 9.63438 14.3445 7.76849 12.0015 7.76849ZM10.7397 12C10.7397 11.3128 11.3084 10.7506 12.0044 10.7506C12.6934 10.7506 13.2538 11.3116 13.2538 12C13.2538 12.6788 12.6936 13.2429 12.0044 13.2429C11.3082 13.2429 10.7397 12.6776 10.7397 12Z"
        fill={color}
      />
    </svg>
  );
};

export { PasswordShowSvg };
